// extracted by mini-css-extract-plugin
module.exports = {"error":"errorBoundary_error__1VOcm","error-msg":"errorBoundary_error-msg__1t3sM"};